var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.11 18.55H16.775L16.73 21.415C16.93 21.315 17.15 21.25 17.39 21.22C17.64 21.18 17.875 21.16 18.095 21.16C18.605 21.16 19.065 21.25 19.475 21.43C19.895 21.6 20.255 21.845 20.555 22.165C20.855 22.475 21.085 22.845 21.245 23.275C21.405 23.695 21.485 24.155 21.485 24.655C21.485 25.185 21.39 25.67 21.2 26.11C21.02 26.54 20.765 26.91 20.435 27.22C20.115 27.52 19.73 27.755 19.28 27.925C18.84 28.095 18.36 28.18 17.84 28.18C17.03 28.18 16.375 28.005 15.875 27.655C15.385 27.305 14.995 26.835 14.705 26.245L15.965 25.765C16.145 26.165 16.405 26.49 16.745 26.74C17.095 26.98 17.495 27.1 17.945 27.1C18.265 27.1 18.56 27.045 18.83 26.935C19.11 26.815 19.35 26.65 19.55 26.44C19.76 26.22 19.925 25.96 20.045 25.66C20.165 25.36 20.225 25.025 20.225 24.655C20.225 24.265 20.155 23.92 20.015 23.62C19.885 23.32 19.7 23.07 19.46 22.87C19.23 22.66 18.955 22.505 18.635 22.405C18.315 22.295 17.97 22.24 17.6 22.24C17.24 22.24 16.87 22.305 16.49 22.435C16.11 22.555 15.76 22.71 15.44 22.9L15.545 17.38H21.11V18.55ZM23.415 22.96H26.835V19.54H27.825V22.96H31.245V23.95H27.825V27.37H26.835V23.95H23.415V22.96Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.65,
    stroke: "#3A3E46",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Plus);
export default __webpack_public_path__ + "static/media/5plus.7a18bb6ec8d01fda47040f55b14757da.svg";
export { ForwardRef as ReactComponent };